export const TELEPHONY_CONNECTOR_DOWNLOADS = {
  windows: '/downloads/NextCab-Telefonie-Connector-Setup-0.4.7-x64.exe',
  macos: '/downloads/NextCab-Telefonie-Connector-Setup-0.4.4-macos.pkg',
  linux: '/downloads/NextCab-Telefonie-Connector-0.3.1-linux-amd64.deb'
};

export const detectTelephonyConnectorDownload = (navigatorValue) => {
  const browserNavigator = navigatorValue || (
    typeof navigator !== 'undefined' ? navigator : null
  );
  if (!browserNavigator) return null;

  const platform = String(
    browserNavigator.userAgentData?.platform ||
    browserNavigator.platform ||
    browserNavigator.userAgent ||
    ''
  ).toLowerCase();
  const userAgent = String(browserNavigator.userAgent || '').toLowerCase();

  if (/android|iphone|ipad|ipod|cros/.test(`${platform} ${userAgent}`)) return null;
  if (platform.includes('win')) {
    return {
      key: 'windows',
      href: TELEPHONY_CONNECTOR_DOWNLOADS.windows,
      label: 'Connector für Windows herunterladen',
      system: 'Windows',
      guidedSetup: true
    };
  }
  if (platform.includes('mac')) {
    return {
      key: 'macos',
      href: TELEPHONY_CONNECTOR_DOWNLOADS.macos,
      label: 'Connector für macOS herunterladen',
      system: 'macOS',
      guidedSetup: true
    };
  }
  if (platform.includes('linux')) {
    return {
      key: 'linux',
      href: TELEPHONY_CONNECTOR_DOWNLOADS.linux,
      label: 'Connector für Linux herunterladen',
      system: 'Linux x64',
      guidedSetup: false
    };
  }
  return null;
};
